/* eslint-disable */ import { memoEval, sceneEntityObjectPropertiesComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const bottomWallItemWithBackPanelComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'backPanel', true).withAlias('BottomWallItemWithBackPanel').withFilter((s)=>s.$backPanelFilter).attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'REAR_PANEL',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'backPanel', true).withAlias('BottomWallItemWithBackPanel').attach(memoEval((self)=>[
            self.$backPanelOffsetZ,
            self.$backPanelWidth,
            self.$backPanelWidthScaleZero,
            self.$backPanelWidthScaleOne
        ], ($backPanelOffsetZ, $backPanelWidth, $backPanelWidthScaleZero, $backPanelWidthScaleOne)=>({
            offsetZ: $backPanelOffsetZ,
            morphTargetInfluences: {
                Width: {
                    value: $backPanelWidth,
                    scaleZero: $backPanelWidthScaleZero,
                    scaleOne: $backPanelWidthScaleOne
                }
            }
        })))
];

//# sourceMappingURL=bottom-wall-item-with-back-panel.js.map